import { getFirestore, collection, doc, getDoc, getDocs, updateDoc, deleteDoc, setDoc, arrayUnion, arrayRemove } from "firebase/firestore";
import { getStorage, ref, uploadBytes, uploadString, getDownloadURL, deleteObject } from "firebase/storage";
import Vue from "vue";
import Axios from "axios";
import VueAxios from "vue-axios";
import { v4 as uuidv4 } from "uuid";

Vue.use(VueAxios, Axios);

const db = getFirestore();

Vue.use(VueAxios, Axios);

const storageInstance = getStorage()
const storageImages = ref(storageInstance, "livesImages/");
const storageVideo = ref(storageInstance, "livesPresentationVideo/");

export default {
    state:{
        livesList: [],
        loadingStatusLiveImage:0,
        loadingStatusLivePresentationVideo:0,
        categoriesLiveList:[],
        livesFilters:[]
    },
    mutations:{
        SET_LIVES_LIST(state, livesList){
            state.livesList = livesList
        },
        SET_CATEGORIES_LIVES_LIST(state, categoriesLivesList){
            state.categoriesLivesList = categoriesLivesList
        },
        SET_VALUE_LOADING_STATUS_LIVE_IMAGE(state, progress) {
            state.loadingStatusLiveImage = progress
        },
        SET_VALUE_LOADING_STATUS_PRESENTATION_VIDEO_LIVE(state, value) {
            state.loadingStatusLivePresentationVideo = value
        },
        SET_LIVES_FILTER_LIST(state, livesFilters) {
            state.livesFilters = livesFilters
        },
        ADD_ANY_VALUE_LIVES_FILTER_LIST(state, data) {
            let indexPrincipal = state.livesFilters.findIndex(filter => filter.type === data.doc)
            state.livesFilters[indexPrincipal].listFilters.push({ name: data.name, children: data.children })
        },
        DELETE_ANY_VALUE_LIVES_FILTER_LIST(state, data) {
            let indexPrincipal = state.livesFilters.findIndex(filter => filter.type === data.doc)
            let index = state.livesFilters[indexPrincipal].listFilters.indexOf(data.item.name)
            state.livesFilters[indexPrincipal].listFilters.splice(index, 1)
        },
        UPDATE_WITH_NEW_VALUES_LIVES_FILTER_LIST_CHILDREN(state, data) {
            let indexPrincipal = state.livesFilters.findIndex(filter => filter.type === data.doc)
            state.livesFilters[indexPrincipal].listFilters = data.updatedArray
        },
        UPDATE_FILTER_LIST_LIVES(state, data) {
            state.livesFilters.push({
                type: data.doc,
                listFilters: data.listFilters,
                name: data.name
            })
        },
        DELETE_VALUE_ROOT_FILTER_LIVES(state, data) {
            let indexPrincipal = state.livesFilters.findIndex(filter => filter.type === data.doc)
            state.livesFilters.splice(indexPrincipal, 1)
        }
    },
    actions:{
        UpdatedParsedLinkLives(){
            return new Promise(async(resolve, reject) => {
                try {
                    const querySnapshot = await getDocs(collection(db, "livesList"))
                    const livesList = []
                    for (let i = 0; i < querySnapshot.docs.length; i++) {
                        let live = querySnapshot.docs[i].data();
                        const regExp = /\/tv\/(.*?)\//;
                        const isValidUrlInstagram =  regExp.test(live.videoLink);
                        if(isValidUrlInstagram){
                            live.parsedVideoLink = `https://www.instagram.com/p/${live.videoLink.match(regExp)[1]}/`
                            await updateDoc(doc(db, "livesList", querySnapshot.docs[i].id), {
                                parsedVideoLink: live.parsedVideoLink
                            })
                        }
                        livesList.push(live)
                        console.log('updated documents: ', i+1)
                    }
                    console.log(livesList);
                } catch (error) {
                    console.error(error);
                    reject(error)
                }

            })

        },
        UpdateLivesOrientation(){
            return new Promise(async(resolve, reject) => {
                try {
                    const querySnapshot = await getDocs(collection(db, "livesList"))
                    const livesList = []
                    for (let i = 0; i < querySnapshot.docs.length; i++) {
                        let live = querySnapshot.docs[i].data();
                        await updateDoc(doc(db, "livesList", querySnapshot.docs[i].id), {
                            turnOrientationLandscape: null
                        })
                        livesList.push(live)
                        console.log('updated documents: ', i+1)
                    }
                    console.log(livesList);
                } catch (error) {
                    console.error(error);
                    reject(error)
                }

            })

        },
                UploadImageLive({ commit }, live) {
            return new Promise(async (resolve, reject) => {
                try {
                    let random = uuidv4();
                    let storageRef = ref(storageInstance, `livesImages/${random}`);
                    console.log('storageRef', storageRef.name);
                    
                    // Upload the string
                    await uploadString(storageRef, live.image.img, "data_url");
                    
                    // Get the download URL
                    const downloadURL = await getDownloadURL(storageRef);
                    resolve({ link: downloadURL, ref: random });
                } catch (error) {
                    console.log('error', error);
                    reject(error);
                }
            });
        },
        UploadPresentationVideoLive({ commit }, live) {
            return new Promise(async (resolve, reject) => {
                try {
                    let random = uuidv4();
                    let storageRef = ref(storageInstance, `livesPresentationVideo/${random}`);
                    let bytes = new Blob([new Uint8Array(live.presentationVideo.blob)]);
                    console.log('storageRef', storageRef.name);
                    let metadata = {
                        contentType: 'video/mp4'
                    }
                    
                    // Upload the bytes
                    await uploadBytes(storageRef, bytes, metadata);
                    
                    // Get the download URL
                    const downloadURL = await getDownloadURL(storageRef);
                    resolve({ link: downloadURL, ref: random });
                } catch (error) {
                    console.log('error', error);
                    reject(error);
                }
            });
        },
        GetLivesList({ commit }){
            return new Promise(async (resolve, reject) => {
                try {
                    const querySnapshot = await getDocs(collection(db, "livesList"))
                    const livesList = []
                    querySnapshot.forEach(async(doc) =>  {
                        let live = doc.data();
                        live.typeWorkout = 'live';

                        live.completedTimes = live.completedTimes ? live.completedTimes : 0;

                        const calories = live.accumulatedCalories ? live.accumulatedCalories : 0;
                        const mxp = live.accumulatedMXP ? live.accumulatedMXP : 0;
                        const completedTimes = live.completedTimes ? live.completedTimes : 0;

                        const avgMXP = completedTimes > 0 ? mxp / completedTimes : 0;
                        const avgCalories = completedTimes > 0 ? calories / completedTimes : 0;

                        live.avgMXP = Number(avgMXP.toFixed(1));
                        live.avgCalories = Number(avgCalories.toFixed(1));

                        livesList.push(live)
                    })
                    commit('SET_LIVES_LIST', livesList)
                    resolve(livesList)
                } catch(error) {
                    reject(error)
                }
            })
        },
        GetLive({ }, live){
            return new Promise(async (resolve, reject) => {
                try {
                    let resLive = await getDoc(doc(db, "livesList", live.id))
                    let gettedLive = resLive.data()
                    if(gettedLive.subscription && gettedLive.subscription != ""){
                        let subscription = await getDoc(doc(db, "subscriptionsList", gettedLive.subscription.id))
                        gettedLive.subscription = subscription.data()
                    }
                    resolve(gettedLive)
                } catch(error) {
                    reject(error)
                }
            })
        },
        GetCategoriesLivesList({ commit }){
            return new Promise(async (resolve, reject) => {
                try {
                    const querySnapshot = await getDocs(collection(db, "categoriesLivesList"))
                    const categoriesLivesList = []
                    querySnapshot.forEach((doc) =>  {
                        categoriesLivesList.push(doc.data())
                    })
                    console.log(categoriesLivesList)
                    commit('SET_CATEGORIES_LIVES_LIST', categoriesLivesList)
                    resolve(categoriesLivesList)
                } catch(error) {
                    reject(error)
                }
            })
        },
        CreateLive({}, live) {
            return new Promise(async(resolve, reject) => {
                try {
                    delete live.image.img
                    if(live.subscription && live.subscription != ""){
                        live.subscription = doc(db, "subscriptionsList", live.subscription.id)
                    }
                    const regExp = /\/tv\/(.*?)\//;
                    const isValidUrlInstagram =  regExp.test(live.videoLink);
                    if(isValidUrlInstagram){
                        live.parsedVideoLink = `https://www.instagram.com/p/${live.videoLink.match(regExp)[1]}/`
                    }
                    const ref = doc(collection(db, "livesList"));
                    const newLive = await getDoc(ref);
                    live.id = ref.id;
                    live.createdAt = new Date()
                    live.updatedAt = new Date()
                    await setDoc(ref, live)
                    resolve(newLive.id);
                } catch (error) {
                    reject(error);
                }
            })
        },
        CreateCategoryLive({}, categoryLive) {
            return new Promise(async(resolve, reject) => {
                try {
                    const ref = doc(collection(db, "categoriesLivesList"));
                    const newCategoryLive = await getDoc(ref);
                    categoryLive.id = ref.id;
                    await setDoc(ref, categoryLive)
                    resolve(ref.id);
                } catch (error) {
                    reject(error);
                }
            })
        },
        UpdateLive({}, live) {
            return new Promise(async(resolve, reject) => {
                try {
                    if(live.createdAt) {
                        delete live.createdAt
                    }
                    live.updatedAt = new Date()
                    if (live.image.img) {
                        delete live.image.img
                    }
                    if(live.subscription && live.subscription != ""){
                        live.subscription = doc(db, "subscriptionsList", live.subscription.id)
                    }
                    const regExp = /\/tv\/(.*?)\//;
                    const isValidUrlInstagram =  regExp.test(live.videoLink);
                    if(isValidUrlInstagram){
                        live.parsedVideoLink = `https://www.instagram.com/p/${live.videoLink.match(regExp)[1]}/`
                    }
                    await updateDoc(doc(db, "livesList", live.id), live)
                    resolve(live.id);
                } catch (error) {
                    reject(error);
                }
            });
        },
        UpdateLiveValue({}, obj){
            return new Promise(async(resolve, reject) => {
                try {
                    await updateDoc(doc(db, "livesList", obj.id), obj.data);
                    resolve(obj.id);
                } catch (error) {
                    reject(error);
                }
            });

        },
        UpdateCategoryLive({}, category) {
            return new Promise(async(resolve, reject) => {
                try {
                    await updateDoc(doc(db, "categoriesLivesList", category.id), category)
                    resolve(category.id);
                } catch (error) {
                    reject(error);
                }
            });
        },
        DeleteLive({}, live) {
            return new Promise(async(resolve, reject) => {
                try {
                    let storageRefImage = ref(storageImages, live.image.ref);
                    await deleteObject(storageRefImage)
                    await deleteDoc(doc(db, "livesList", live.id))
                    resolve(live.id)
                } catch (error) {
                    reject(error);
                }
            });
        },
        DeleteCategoryLive({}, category) {
            return new Promise(async(resolve, reject) => {
                try {
                    await deleteDoc(doc(db, "categoriesLivesList", category.id))
                    resolve(category.id)
                } catch (error) {
                    reject(error);
                }
            });
        },
        //Filters
        GetFiltersListLives({ commit }) {
            return new Promise(async(resolve, reject) => {
                try {
                    const querySnapshot = await getDocs(collection(db, "livesFilters"))
                    const livesFilters = [];
                    querySnapshot.forEach((doc) => {
                        let filterLives = doc.data();
                        filterLives.type = doc.id
                        livesFilters.push(filterLives);
                    });
                    commit("SET_LIVES_FILTER_LIST", livesFilters);
                    resolve(livesFilters); 
                } catch (error) {
                    reject(error)
                }
            });
        },
        AddNewTypeToListOfFiltersLives({ commit }, data) {
            return new Promise(async(resolve, reject) => {
                try {
                                         const res = await updateDoc(doc(db, "livesFilters", data.doc), {
                         listFilters: arrayUnion({ name: data.name, children: data.children })
                      })
                    commit("ADD_ANY_VALUE_LIVES_FILTER_LIST", data);
                    resolve(res);
                } catch (error) {
                    reject(error)
                }
            })
        },
        DeleteTypeToListOfFiltersLives({ commit }, data) {
            return new Promise(async(resolve, reject) => {
                try {
                                       const res = await updateDoc(doc(db, "livesFilters", data.doc), {
                         listFilters: arrayRemove(data.item)
                     })
                        commit('DELETE_ANY_VALUE_LIVES_FILTER_LIST', data)
                        resolve(res);
                } catch (error) {
                        reject(error);
                }
            })
        },
        AddOrDeleteChildrenToListOfFiltersLives({ commit }, data) {
            return new Promise(async(resolve, reject) => {
                try {
                    const res = await updateDoc(doc(db, "livesFilters", data.doc), {
                        listFilters: data.updatedArray
                    })
                    commit("UPDATE_WITH_NEW_VALUES_LIVES_FILTER_LIST_CHILDREN", data);
                    resolve(res);
                } catch (error) {
                    reject(err);
                }
            })
        },
        CreateNewFilterLives({ commit }, data) {
            return new Promise(async(resolve, reject) => {
                try {
                    const res = await setDoc(doc(db, "livesFilters", data.doc), {
                        name: data.name,
                        listFilters: data.listFilters,
                    })
                    commit("UPDATE_FILTER_LIST_LIVES", data);
                    resolve(res);
                } catch (error) {
                    reject(err);
                }
            })
        },
        DeleteFilterLives({ commit }, data) {
            return new Promise(async(resolve, reject) => {
                try {
                    const res = await deleteDoc(doc(db, "livesFilters", data.doc))
                    commit("DELETE_VALUE_ROOT_FILTER_LIVES", data);
                    resolve(res);
                } catch (error) {
                    reject(err);
                }
            })
        },
    },
    getters:{
        getLivesList(state){
            return state.livesList;
        },
        getLoadingStatusLiveImage(state){
            return state.loadingStatusLiveImage;
        },
        getLoadingStatusLivePresentationVideo(state){
            return state.loadingStatusLivePresentationVideo;
        },
        getCategoriesLivesList(state){
            return state.categoriesLivesList;
        },
        getLivesFilters(state) {
            return state.livesFilters
        },
    }
}